// extracted by mini-css-extract-plugin
export default {"container":"KgSJw5","image":"mf6Qgn","content":"wZxQry","cta":"Kk7Edo"};